export const CONFIG = {
    baseUrl:"https://algorithma.gateway.dev.fegno.com/api/v1",
    cdnBase:"https://algorithma.gateway.dev.fegno.com"
}